import request from '../utils/request'
import QS from "qs";

export function exchangeGoods (id,data) {
  return request({
    url: `/api/shoper/order/${id}/exchange`,
    method: 'put',
    data:QS.stringify(data),
  })
}

